interface PaymentData {
  sessionId: number
  sessionAuthCode: string
}

const makePaymentDataHolder = () => {
  let sessionId: number
  let sessionAuthCode: string

  const updatePaymentData = (paymentData: PaymentData) => {
    sessionId = paymentData.sessionId
    sessionAuthCode = paymentData.sessionAuthCode
  }

  return Object.freeze({
    getSessionId: (): number | undefined => sessionId,
    getSessionAuthCode: (): string | undefined => sessionAuthCode,
    updatePaymentData: updatePaymentData,
  })
}

const paymentDataHolder = makePaymentDataHolder()

export default paymentDataHolder
